import React from 'react';

const LayoutStateContext = React.createContext();
const LayoutDispatchContext = React.createContext();

function layoutReducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR':
      return { ...state, isSidebarOpened: !state.isSidebarOpened };
    case 'TOGGLE_PERMANENT':
      return { ...state, permanent: !action.payload };
    case 'SET_LOCATION_MODAL':
      return { ...state, locationModal: action.payload };
    case 'SET_BUSINESS_MODAL':
      return { ...state, businessModal: action.payload };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function LayoutProvider({ children }) {
  const [state, dispatch] = React.useReducer(layoutReducer, {
    isSidebarOpened: false,
    locationModal: false,
    businessModal: false,
    permanent: false,
  });
  return (
    <LayoutStateContext.Provider value={state}>
      <LayoutDispatchContext.Provider value={dispatch}>
        {children}
      </LayoutDispatchContext.Provider>
    </LayoutStateContext.Provider>
  );
}

function useLayoutState() {
  const context = React.useContext(LayoutStateContext);
  if (context === undefined) {
    throw new Error('useLayoutState must be used within a LayoutProvider');
  }
  return context;
}

function useLayoutDispatch() {
  const context = React.useContext(LayoutDispatchContext);
  if (context === undefined) {
    throw new Error(
      'useLayoutDispatch must be used within a LayoutProvider',
    );
  }
  return context;
}

const toggleSidebar = (dispatch) => {
  dispatch({
    type: 'TOGGLE_SIDEBAR',
  });
};

const togglePermanent = (value, dispatch) => {
  dispatch({ type: 'TOGGLE_PERMANENT', payload: value });
};
const setLocationModal = (value, dispatch) => {
  dispatch({ type: 'SET_LOCATION_MODAL', payload: value });
};
const setBusinessModal = (value, dispatch) => {
  dispatch({ type: 'SET_BUSINESS_MODAL', payload: value });
};
export {
  LayoutProvider,
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
  togglePermanent,
  LayoutStateContext,
  setLocationModal,
  setBusinessModal,
};
